import { EFFormComponent } from "../form/EFFormComponent";
import { observer } from "mobx-react";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import { flattenEAFormData } from "../form/utils/toRequestBody";
// 需要特殊處理的 cat
const specialCats = [];

export const SchemaSwitcher = observer(({ cat, defaultEFSchema }) => {
  const { _handleSetEFFormData, EAFormData } = emissionViewStore;
  const flatEAFormData = flattenEAFormData(EAFormData);
  let configs = [];

  ////////通常情況
  if (!specialCats.includes(cat)) {
    return (
      <EFFormComponent
        EFSchema={defaultEFSchema}
        formDataKey={"EFFormData"}
        handleSetFormData={_handleSetEFFormData}
        target={"EFFormData"}
      />
    );
  }

  if (configs.length === 0 || !flatEAFormData.calculationId) {
    return [];
  }

  ////////3.1 3.2 4.3特殊處理

  return configs.map(({ schema, formDataKey, target }, index) => (
    <EFFormComponent
      key={index}
      EFSchema={schema}
      formDataKey={formDataKey}
      handleSetFormData={_handleSetEFFormData}
      target={target}
    />
  ));
});
